//Node Modules
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//My Components

//3rd Party Components

//State

//Config

//Helpers

//Other

const MenuLink = ({ path, id, ref, label, icon, items, buttonClass, showDropIcon = false, children }) => {
	//Hooks
	const { t } = useTranslation();
	const { pathname } = useLocation();

	//Local State
	const [isMatchLocation, setIsMatchLocation] = useState(false);

	useEffect(() => {
		if (pathname.startsWith(path)) setIsMatchLocation(true);
	}, [pathname, path]);

	const handleClick = (command) => {
		command();
	};

	const renderItemContent = (item) => {
		if (item.separator) {
			return <div className="separator"></div>;
		} else if (item.template) {
			return item.template();
		} else if (item.disabled) {
			return (
				<div className="menuItem disabled">
					{item.icon && <i className={item.icon} />}
					{item.label && <span>{item.label}</span>}
				</div>
			);
		} else if (item.command) {
			return (
				<div className="menuItem" onClick={() => handleClick(item.command)}>
					{item.icon && <i className={item.icon} />}
					{item.label && <span>{item.label}</span>}
				</div>
			);
		} else if (item.url) {
			return (
				<Link to={item.url} className="menuItem">
					{item.icon && <i className={item.icon} />}
					{item.label && <span>{item.label}</span>}
				</Link>
			);
		} else if (item.urlExternal) {
			return (
				<a href={item.urlExternal} target="_blank" className="menuItem">
					{item.icon && <i className={item.icon} />}
					{item.label && <span>{item.label}</span>}
				</a>
			);
		}
	};

	return (
		<div className="menuLink-wrapper">
			<div ref={ref} className={`menuLink-button ${buttonClass}`} style={{ anchorName: "test" }} data-active-location={isMatchLocation}>
				{icon && <i className={icon} />}
				{label && <span>{label}</span>}
				{showDropIcon && <i className="bi bi-chevron-down" />}
			</div>

			<div className="menuLink-menu" style={{ positionAnchor: "test" }}>
				{items ? (
					<ul role="menu">
						{items
							.filter((item) => {
								if (item.visible === false) return false;
								return true;
							})
							.map((item, index) => (
								<li key={`menuItem-${id}-${index}`}>{renderItemContent(item)}</li>
							))}
					</ul>
				) : (
					children
				)}
			</div>
		</div>
	);
};

export default MenuLink;
